var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[("" + _vm.cssPrefix),
    (_vm.cssPrefix + "--country-" + _vm.effectiveId),
    ( _obj = {}, _obj[(_vm.cssPrefix + "--bottom")] = _vm.bottomAlign, _obj[(_vm.cssPrefix + "--block")] = _vm.asBlock, _obj[(_vm.cssPrefix + "--clickable")] = _vm.clickable, _obj[(_vm.cssPrefix + "--rounded")] = _vm.rounded, _obj ) ],style:(_vm.rootStyle),attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }